import React from "react";
import './c22_bandi_aperti.scss';
import DoubleTemplateComponent from "../../containers/template_page/double_template_component/double_template_component";
//import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import {isMobileOnly} from "react-device-detect";
import axios from "axios";
import Moment from "react-moment";

let queryDepartment = '';
let queryContractTypology = '';
class BandiAperti extends DoubleTemplateComponent {
    uuid = '';

    constructor(props) {
        super(props);
        this.state = {
            departmentsList: [],
            contractTypologyList: [],
            optionsCategory: [],
            arrayCallCat: [],
            disabled: true,
            isHidden: true,
            valueDepartmentsList: 'All',
            valueContractTypologyList: 'All'
        };
        this.requireInternationalization = true;
    };

    onOtherDataLoaded(index, data) {
        if (index === 0) {
            this.setState({departmentsList: data.terms});
            this.state.departmentsList.unshift({id: "1", label: "All", weight: "0", langcode: "it"});
        } else if (index === 1) {
            this.setState({contractTypologyList: data.terms});
            this.state.contractTypologyList.unshift({id: "2", label: "All", weight: "0", langcode: "it"});
        }
    }

    changeDepartment = selected => {
        selected = selected.value;
        this.getValueDepartmentsList(selected);

        if (selected === 'All') {
            selected = '';
            this.uuid = '';
            queryDepartment = this.uuid;
        }
        // for each category in arrayCallCat find uuid based on selected value of category name
        this.state.departmentsList.forEach((filterString) => {
            for (var key in filterString) {
                if (filterString[key] === selected) {
                    this.uuid = `&dep=${filterString.id}`;
                    queryDepartment = this.uuid;
                }
            }
        });
        this.createQueryString();
    };

    changeContractTypology = selected => {
        selected = selected.value;
        this.getValueContractTypologyList(selected);
        if (selected === 'All') {
            selected = '';
            this.uuid = '';
            queryContractTypology = this.uuid;
        }

        // for each category in arrayCallCat find uuid based on selected value of category name
        this.state.contractTypologyList.forEach((filterString) => {
            for (var key in filterString) {
                if (filterString[key] === selected) {
                    this.uuid = `&typec=${filterString.id}`;
                    queryContractTypology = this.uuid;
                }
            }
        })
        this.createQueryString();
    };

    createQueryString = () => {
        this.callFilter(queryDepartment+queryContractTypology);
    };

    callFilter = (value) => {
        axios.get(`${this.state.data.__data}${value}`, {})
            .then(res => {
                this.setState({
                    data: {...this.state.data, ...res.data}
                });
            });
    };

    getValueDepartmentsList = val => {
        this.setState({valueDepartmentsList: val});
    };
    getValueContractTypologyList = val => {
        this.setState({valueContractTypologyList: val});
    };

    showMore = ep => {
        axios.get(ep, {}).then(res => {
            let cards = this.state.data.contracts.concat(res.data.contracts);
            this.setState({
                callMore: true,
                data: {...this.state.data, ...{contracts: cards, next_page: res.data.next_page}}
            });
        });
    };

    internationalComponentRender(allData, t) {
        let filteredCards = allData.contracts;

        return (
            <div id={!isMobileOnly ? 'bandi-aperti' : 'bandi-aperti-mob'}>
                <div className="container">
                    <div className="row">
                        <div className="bandi-title">{allData.title}</div>
                    </div>
                    {/* HIDE DROPDOWN FOR FILTERING BANDI
                    <div className="row">
                        <Dropdown
                            options={this.state.departmentsList}
                            onChange={this.changeDepartment}
                            value={this.state.valueDepartmentsList}
                            placeholder="All"
                            className="bandi-departmentsList col-xl-4 col-md-6"
                        />
                        <Dropdown
                            options={this.state.contractTypologyList}
                            onChange={this.changeContractTypology}
                            value={this.state.valueContractTypologyList}
                            placeholder="All"
                            className="bandi-contractTypologyList col-xl-4 col-md-6"
                        />
                    </div>*/}
                    <div className="row">
                        {(filteredCards && filteredCards.length > 0) ? filteredCards.map((card, index) => (
                            <div key={index} className="col-xl-4 col-md-6 mb-5">
                                <div className="bandi-card">
                                    {card.card_code ?
                                        <div className="codice-concorso">{t("C22 - Recruitment Code")+card.card_code}</div> : null}
                                    {card.card_title ? <div className="bandi-card-title">{card.card_title}</div> : null}
                                    {card.card_subtitle ?
                                        <div className="bandi-card-subtitle">{card.card_subtitle}</div> : null}
                                    {card.card_scadenza ?
                                        <div className="bandi-card_scadenza">
                                            {t("C22 - Application Deadline")}
                                        <Moment date={card.card_scadenza} format="D MMMM YYYY"/>
                                        </div> : null}
                                    {card.cta_white ? <button className="bandi-card-button-white"><a
                                        href={card.url_white}>{card.cta_white}</a></button> : null}
                                </div>
                            </div>
                        )) : <p className={'not-found'}>{t("C41 grid no content")}</p>}
                    </div>
                    <div className="row">
                        {allData.next_page !== '' && (filteredCards && filteredCards.length > 0) ?
                            <button className="bandi-button"
                                    onClick={() => this.showMore(allData.next_page)}>{allData.loadmore_label}</button> : null}
                    </div>
                </div>
            </div>
        )
    }
}

export default BandiAperti;
